import axios from 'axios'
import router from '../router'
import {getUrlSearchParams} from '../utils/requestParamsHelper'
import {Message, Loading} from "element-ui";

axios.interceptors.request.use(config => {
    const token = localStorage.getItem("token");
    if(token) {
        config.headers = {
            "Authorization": "Bearer " + token
        }
    }
    return config;
});

axios.interceptors.response.use(function (response) {
    if(!response.data.success) {
        Message.error(response.data.msg);
        return Promise.reject();
    }
    return Promise.resolve(response.data.data);
}, function (error) {
    console.log(error)
    const status = error.response.status;
    if(status == 401) {
        router.replace("/login");
        Loading.service({}).close()
        Promise.resolve();
    } else if(status == 403) {
        router.replace("/401");
        Promise.resolve();
    } else {
    }
    return Promise.reject(error);
});

function post(url, payload) {
    return axios.post(url, getUrlSearchParams(payload));
}

function postJson(url, payload) {
    return axios.post(url, payload);
}

export {axios, post, postJson};
